import Container from 'components/Container';
import { ROUTES } from 'constants/index';
import { useTranslation } from 'services/hooks';

import './style.css';

function MissingPage() {
	const getTranslation = useTranslation();

	const TRANSLATION_KEY = 'missing_page';

	return (
		<Container className="MissingPage">
			<div className="main_title">404</div>
			<div className="sub_title">
				<span dangerouslySetInnerHTML={{ __html: getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_sub_title`) }}></span>{' '}
				<a href={ROUTES.LOGIN}>{getTranslation(TRANSLATION_KEY, `${TRANSLATION_KEY}_sub_title_link`)}</a>
			</div>
		</Container>
	);
}

export default MissingPage;
